import { z } from 'zod'
import { oc } from '@orpc/contract'

export const healthcheck = oc
  .route({ method: 'GET', path: '/v2/healthcheck' })
  .input(z.object({ ping: z.string().optional() }))
  .output(
    z.object({
      status: z.literal('ok'),
      pong: z.string().optional(),
    }),
  )
